import React from 'react';
import poomalakavulocation from '../assets/kavumainpageimg/poomalakavu-location.jpg';

const Footer = () => (
    <footer className="main-footer">
        <div className="footer-content">
            <div className="footer-map">
                <a href="https://www.google.com/maps/place/Thalayanneri+Temple/@12.1331664,75.1995015,18z/data=!4m6!3m5!1s0x3ba46e7c4a7d84ad:0x5b28f70bfc103748!8m2!3d12.1334942!4d75.1981261!16s%2Fg%2F11g9j7g_l8?entry=ttu&g_ep=EgoyMDI1MDYzMC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                    <img src={poomalakavulocation} alt="Temple Location Map" />
                </a>
            </div>
            <div className="footer-details">
                <h4>ശ്രീ തലയന്നേരി പൂമാല ഭഗവതി കാവ്</h4>
                <p>അന്നൂർ, പയ്യന്നൂർ, കണ്ണൂർ ജില്ല, കേരളം, ഇന്ത്യ</p>
                <p>ഇമെയിൽ: sreethalayanneripoomala@gmail.com | ഫോൺ: +91 917907852971</p>
                <p>© 2025 ശ്രീ തലയന്നേരി പൂമാല ഭഗവതി കാവ്. എല്ലാ അവകാശങ്ങളും നിക്ഷിപ്തം.</p>
                <p><a href="/privacy-policy">സ്വകാര്യതാ നയം</a> | <a href="/termsandconditions">നിബന്ധനകളും വ്യവസ്ഥകളും</a></p>
            </div>
        </div>
    </footer>
);

export default Footer;